import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { useForm } from "react-hook-form";
import { Button, FormGroup, Label, Input, FormText } from 'reactstrap';
import HeaderPage from '../HeaderPage/HeaderPage.js';
import FooterPage from '../FooterPage/FooterPage.js';
import Footer from '../../../_Common/Footer';
import { getUserAction, UpdateUserAction, getAllFavoritesAction, getAllFavoriteRecipesAction, GetCronometerData, GetAllCronometerData } from '../../Actions/User.action';
import { getAllDefaultFiltersAction } from '../../Actions/Utility.action';
import { appConstants } from '../../../_Constants';
import toaster from '../../../_Common/Toaster';
import ButtonLoader from '../../../_Common/ButtonLoader';
import { ConfirmModalComponent } from '../../../_Common/Modal';
import { FormError, ShowFormErrors, ShowFormValidErrors } from "../../../_Common/FormError";
import './CalibrateComplete.css';

//import $ from "jquery";



/**
 * [Pofile Page Component]
 * @param  {[type]} options.history [array]
 */
const CalibrateComplete = ({ history }) => {

    const [formErrors, setFormErrors] = useState({});
    const { register, errors, getValues, handleSubmit, reset } = useForm();
    const [fieldName, setFieldName] = useState()
    const [formData, setFormData] = useState({});
    const [buttonActive, setButtonActive] = useState('false');
    const [allergen, setAllergen] = useState([]);
    const [keto, setKeto] = useState([]);
    const [planet, setPlanet] = useState([]);
    const [nutrition, setNutrition] = useState([]);
    const [preferenceList, setPreferenceList] = useState([]);
    const [vegetarianVegan, setVegetarianVegan] = useState([]);
    const [favoritesList, setFavoritesList] = useState([]);
    const [favoriteRecipesList, setFavoriteRecipesList] = useState([]);
    const [loader, setLoader] = useState('false');
    const [modalRestaurant, setModalRestaurant] = useState(false);
    const [modalRecipe, setModalRecipe] = useState(false);
    const [confirmStatus, setConfirmStatus] = useState(false);
    const [clientName, setClientName] = useState(false);
    const [nutritionStatus, setCheckNutrition] = useState(false);
    const [userName, setuserName] = useState();
    const [nutritionRange, setNutritionRange] = useState(appConstants.nutritionRange);
    /**
     * [Input Change value]
     * @param  {[type]} e     [element object]
     * @param  {[type]} field [name of field]
     */
    const onChange = (e, field) => {
        e.preventDefault();
        let formData1 = formData;
        formData1[field] = e.target.value;
        setFormData({ ...formData1 });
        setFieldName(field);
    }

    useEffect(() => {
        document.title = "MyMenuMoonshot-Calibrate";
    }, []);

    return (
        <div className="App">
            <HeaderPage setFormData={formData} />
            <header className="App-header">
                <div className="inner_page_main_new Profile_page">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="inner_page_innersec">
                                    <p style={{ 'color': '#ef2859', fontSize: '28px', fontWeight: 'bold' }}>Calibrate</p>
                                    <div className="widget" style={{ background: "white", padding: "30px", borderRadius: "10px", textAlign: "center" }}>
                                        <img style={{ margin: "20px", height: "100px" }} src="/static/img/moonfilled.png" alt="Assessment Complete" />
                                        <p style={{ fontSize: '24px' }}>Assessment Complete!</p>
                                        <p>Your profile settings will inform your personalized nutrition plan.</p>
                                        <p>Next, you'll have the opportunity to set preferences about your eating styles and/or food allergies.</p>
                                        <br></br>
                                        <br></br>
                                        <div onClick={() => window.location.href='/dashboard'} style={{ display: "inline", cursor: "pointer" }} className="continue_search_landing_preferences event center">SET PREFERENCES</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
</header >
        </div>
            



    );
}
export default withLocalize(withRouter(CalibrateComplete));


